import { CardBlock, FieldBlock, ImageBlock, InputBlock } from '@coast/schemas';
import { isEmpty, isNil } from 'lodash';
import { API } from '@shared/types/api';
import { Fields, Reminder, TodoItem } from './types';

export function getFieldValue(fields: Fields, block: FieldBlock | ImageBlock | InputBlock) {
  return fields[block.name];
}

export function nonRedactedBlocks(card: API.CardFragment) {
  return (block: CardBlock) => {
    if (card.planLimitImposed) {
      return block.type === 'field' && block.name === 'name';
    }
    return true;
  };
}

export function nonEmptyBlocks(
  fields: Fields,
  canReadThread: boolean,
  canCreateThread: boolean,
  canUpdateCard: boolean,
  printing: boolean,
) {
  return (block: CardBlock) => {
    switch (block.type) {
      case 'image':
        return !!fields[block.name];
      case 'field':
        if (
          block.fieldType === 'questionCheckbox' ||
          block.fieldType === 'questionTextArea' ||
          block.fieldType === 'questionSingleSelect'
        ) {
          return true;
        }
        if (block.fieldType === 'toggle' || block.fieldType === 'channel') {
          return true;
        }
        if (block.fieldType === 'todo') {
          const todos: TodoItem[] = fields[block.name];
          return !isEmpty(todos);
        }
        if (block.fieldType === 'reminder') {
          const reminders: Reminder[] = fields[block.name];
          return !isEmpty(reminders);
        }
        return ![null, undefined, ''].includes(fields[block.name]);
      case 'seen-by':
        return !isNil(fields.threadId) && !printing;
      case 'chat-thread':
        return !isNil(fields.threadId) && !printing && canReadThread;
      case 'chat-thread-input':
        return !isNil(fields.threadId) && !printing && canCreateThread;
      case 'date-range': {
        const startDateFieldName = block.startDateFieldName ?? 'startDate';
        const endDateFieldName = block.endDateFieldName ?? 'endDate';
        return !isNil(fields[startDateFieldName]) && !isNil(fields[endDateFieldName]);
      }
      case 'button':
        return canUpdateCard && !printing;
      case 'sequenceNumber':
        return !isNil(fields.sequenceNumber);
      case 'input':
      default:
        return true;
    }
  };
}
